import React from "react";
import { PhoneCall, MessageSquare, UserRound } from "lucide-react";

const fmt = (p) => { const d = (p || "").replace(/\D/g, "").slice(-10); return d.length === 10 ? `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}` : p; };

export const CaseHelp = ({ handoff, contact, onRequestAdvisor }) => {
  if (!handoff?.needed && !contact) return null;
  return (
    <section className="rounded-xl border-2 border-[#1E3E62] bg-[#F2F5F9] p-5" data-testid="case-help">
      {handoff?.message && <p className="text-base font-semibold text-[#0B192C]" data-testid="case-help-message">{handoff.message}</p>}
      {handoff?.checks?.length > 0 && <ul className="mt-2 list-disc pl-5 text-sm text-[#33475B]">{handoff.checks.map((c, i) => <li key={i}>{c}</li>)}</ul>}
      <div className="mt-4 flex flex-wrap gap-3">
        {contact?.phone && (
          <a href={`tel:${contact.phone}`} className="inline-flex h-11 items-center gap-2 rounded-full bg-[#1E3E62] px-5 font-semibold text-white" data-testid="case-help-call">
            <PhoneCall className="h-4 w-4" />Call {contact.label} · {fmt(contact.phone)}
          </a>
        )}
        {contact?.phone && contact.smsReady && (
          <a href={`sms:${contact.phone}`} className="inline-flex h-11 items-center gap-2 rounded-full border border-[#1E3E62] bg-white px-5 font-semibold text-[#1E3E62]" data-testid="case-help-text">
            <MessageSquare className="h-4 w-4" />Text {contact.label}
          </a>
        )}
        {onRequestAdvisor && (
          <button type="button" onClick={onRequestAdvisor} className="inline-flex min-h-11 items-center gap-2 rounded-full border border-[#BCCCDC] bg-white px-5 py-2 text-left font-semibold text-[#1E3E62]" data-testid="case-help-request">
            <UserRound className="h-4 w-4" />Ask a licensed advisor to call me
          </button>
        )}
      </div>
      <p className="mt-3 text-xs text-[#5A6B7B]">Your answers and this comparison are saved with your conversation so an advisor can pick up where you left off.</p>
    </section>
  );
};
